import { useEffect, useState } from "react";

import { Skeleton } from "@mui/material";
import { Grid } from "@mui/material";

import MDBox from "components/MDBox";

import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import { isFiniteNumber } from "helpers/chartDataUtils";
import { calcularPorcentagemDiferenca } from "helpers/utils";

import { getEstatisticaRegisterWeek } from "services/reports";

type Props = {
  gridLg?: 3 | 4;
};

export default function StaticticsCardRegisterAtletas({ gridLg = 3 }: Props) {
  const [isLoading, setIsLoading] = useState(true);
  const [valueFirstWeek, setValueFirstWeek] = useState<number | null>(null);
  const [valueSecondWeek, setValueSecondWeek] = useState<number | null>(null);
  const [valueTotalAtleta, setValueTotalAtleta] = useState<number | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const { totalAtleta, firstWeek, secondWeek } =
          await getEstatisticaRegisterWeek();
        setValueFirstWeek(firstWeek ?? null);
        setValueSecondWeek(secondWeek ?? null);
        setValueTotalAtleta(totalAtleta ?? null);
      } catch {
        setValueFirstWeek(null);
        setValueSecondWeek(null);
        setValueTotalAtleta(null);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return (
      <>
        <Grid item xs={12} md={6} lg={gridLg}>
          <MDBox mb={1.5}>
            <Skeleton variant="rounded" height={120} />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={gridLg}>
          <MDBox mb={1.5}>
            <Skeleton variant="rounded" height={120} />
          </MDBox>
        </Grid>
      </>
    );
  }

  const weeklyStats =
    isFiniteNumber(valueFirstWeek) && isFiniteNumber(valueSecondWeek)
      ? calcularPorcentagemDiferenca(valueSecondWeek, valueFirstWeek)
      : null;

  return (
    <>
      <Grid item xs={12} md={6} lg={gridLg}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="success"
            icon="people"
            title="Total"
            count={isFiniteNumber(valueTotalAtleta) ? valueTotalAtleta : "—"}
            percentage={{
              color: "success",
              amount: "",
              label: "Atletas Cadastrados no site",
            }}
          />
        </MDBox>
      </Grid>
      <Grid item xs={12} md={6} lg={gridLg}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            icon="leaderboard"
            title="Cadastros últimos 7 dias"
            count={isFiniteNumber(valueFirstWeek) ? valueFirstWeek : "—"}
            percentage={{
              color: weeklyStats?.variacaoPositiva ? "success" : "error",
              amount: weeklyStats?.percentageFormated ?? "",
              label: "semana anterior",
            }}
          />
        </MDBox>
      </Grid>
    </>
  );
}
